module.exports = __webpack_public_path__ + "img/page2-three.c289e435.png";